import { render } from "./GoogleMaps.vue?vue&type=template&id=2a88bf21"
const script = {}

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__